var _defs, _polygon, _polygon2, _polygon3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoncuffsleeve01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 423 520",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-75,.cls-74{fill:#fff;stroke:#010101;stroke-miterlimit:10;}.cls-75{stroke-width:3px;}.cls-74{stroke-dasharray:3;}"))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-75",
    points: "350.83 390.38 264.61 445.97 250.37 427.21 339.1 368.67 350.83 390.38"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-74",
    points: "253.25 427.7 338.38 371.54 348.19 389.7 265.08 443.29 253.25 427.7"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-75",
    points: "339.1 368.67 250.37 427.21 228.33 398.16 228.31 398.18 71.17 201.2 194.21 72.03 322.58 338.1 339.1 368.67"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoncuffsleeve01);
export default __webpack_public_path__ + "static/media/NON CUFF SLEEVE-01.7dea8b01b4f336163fbee51bd59261b8.svg";
export { ForwardRef as ReactComponent };